// Verifizierte Kundenbewertungen — die EINZIGE Quelle fuer Bewertungs-Bloecke.
//
// Warum es diese Datei gibt (Janik 17.09.2026): Die Paywall zeigte dasselbe
// Zitat je Sprache unter anderem Namen (DE Daniel Brettschneider / EN Marc
// Williams / FR Marcel Weidner / IT Giuliano Strecker …) direkt neben "Echte
// Bewertungen auf Google". Im Repo existieren keine Google- oder OMR-Daten,
// also wird nichts mehr gezeigt, bis echte Bewertungen hier eingetragen sind.
//
// REGELN FUER EINTRAEGE
//   - Ein Name pro Person, in JEDER Sprache identisch. Namen sind nie i18n-Keys.
//   - `text` ist das woertliche Original von der Plattform.
//   - `sourceUrl` zeigt auf GENAU diese Bewertung; `verifiedAt/By` sagt, wer sie
//     wann dort nachgesehen hat.
//   - Kein Foto ohne dokumentierte Einwilligung (`consentRef`), sonst Initialen.
//
// GELOESCHT (LEA-619), NICHT NEU ANLEGEN: og.trust.tstm.*, og.split.testimonial.*,
// og.trust.proof.pill und prism.reviews.pill. Deren Namen wichen je Sprache ab
// bzw. waren Platzhalter, und die Pills behaupteten Plattformen, die wir nicht
// belegen koennen. Echte Bewertungen kommen ausschliesslich hier hinein.

export type ReviewPlatform = 'google';

export type VerifiedReview = {
  /** Plattform-ID der Bewertung — stabiler React-Key. */
  id: string;
  platform: ReviewPlatform;
  /** Oeffentliche URL genau dieser Bewertung. */
  sourceUrl: string;
  rating: 1 | 2 | 3 | 4 | 5;
  author: {
    /** Ein Name, in jeder Sprache gleich. */
    name: string;
    role?: string;
    /** Nur mit Einwilligung (consentRef). */
    photo?: string;
    consentRef?: string;
  };
  /** Woertliches Original von der Plattform. */
  text: string;
  /** ISO-Datum, an dem jemand sourceUrl geprueft hat. */
  verifiedAt: string;
  verifiedBy: string;
};

export const VERIFIED_REVIEWS: readonly VerifiedReview[] = [];

/** Unter dieser Zahl wird gar kein Block gezeigt — ein einzelnes Zitat wirkt handverlesen. */
export const MIN_REVIEWS_TO_SHOW = 3;

export const REVIEW_PLATFORM_LABEL: Record<ReviewPlatform, string> = {
  google: 'Google',
};

export function selectVerifiedReviews(limit?: number): readonly VerifiedReview[] {
  if (VERIFIED_REVIEWS.length < MIN_REVIEWS_TO_SHOW) return [];
  return typeof limit === 'number' ? VERIFIED_REVIEWS.slice(0, limit) : VERIFIED_REVIEWS;
}
